import { render, staticRenderFns } from "./AddBlockConstructor.vue?vue&type=template&id=5ee0a34a&scoped=true"
import script from "./AddBlockConstructor.vue?vue&type=script&lang=js"
export * from "./AddBlockConstructor.vue?vue&type=script&lang=js"
import style0 from "./AddBlockConstructor.vue?vue&type=style&index=0&id=5ee0a34a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee0a34a",
  null
  
)

export default component.exports